import { render } from "./Role.vue?vue&type=template&id=1a9d2bfb&ts=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__